import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        '&.MuiDataGrid-root .MuiDataGrid-columnsContainer': {
            border: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer': {
            justifyContent: 'center',
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader--moving': {
            backgroundColor: 'white',
        },
        '&>.MuiDataGrid-main': {
            '&>.MuiDataGrid-columnHeaders': {
                borderBottom: 'none',
            },
            '& div div div div >.MuiDataGrid-cell': {
                borderBottom: 'none',
                justifyContent: 'center'
            },
            '& div div div div >.MuiDataGrid-cell:nth-of-type(4)': {
                justifyContent: 'center'
            },
            '& div div div div >.MuiDataGrid-cell:nth-of-type(3)': {
                justifyContent: 'flex-end'
            },
            '& div div div div >.MuiDataGrid-cell:nth-of-type(1)': {
                justifyContent: 'center'
            },
        },
        '&.MuiDataGrid-root .MuiDataGrid-iconButtonContainer .MuiIconButton-label': {
            display: 'none',
        }
    }
}));